import { createAuthContext } from '@fanadise/common-logic';
import { Admin } from '@fanadise/common-types';

const AppAuthContext = createAuthContext<Admin>();

export default AppAuthContext;
